/**
 * 禁止移动端页面被放大（双指缩放 / 双击放大 / 桌面 Ctrl+滚轮）
 *
 * 各平台为什么需要不同手段：
 * - 安卓（含微信安卓）：viewport 里的 maximum-scale=1、user-scalable=no 就够；
 * - iOS Safari 从 iOS 10 起会**忽略** user-scalable=no，只能靠 gesturestart / touchmove 拦；
 * - 部分国产浏览器（UC、QQ）会忽略 viewport，需要事后把它重写一次把缩放纠正回来；
 * - iOS 输入框字号小于 16px 时聚焦会自动放大，见 style/index.css 里的处理。
 */

// 锁定用的 viewport 内容，和 public/index.html 里保持一致
const VIEWPORT_LOCK =
  'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover';

let lastTouchEnd = 0;
let installed = false;

// 把 viewport 重新写一遍。有的安卓浏览器会忽略 user-scalable，
// 重新写一次能让它按新规则重新排版，把已经放大的画面纠正回来。
function lockViewport() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  if (meta.getAttribute('content') !== VIEWPORT_LOCK) {
    meta.setAttribute('content', VIEWPORT_LOCK);
  }
}

// 已经被放大了（visualViewport.scale > 1）就强制重置一次。
// 先退化成一个最简 viewport 再写回锁定值，浏览器才会重新解析并丢掉缩放。
function enforceScale() {
  const vv = window.visualViewport;
  if (!vv || vv.scale <= 1.01) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  meta.setAttribute('content', 'width=device-width,initial-scale=1');
  meta.setAttribute('content', VIEWPORT_LOCK);
}

// 双指及以上：直接拦截
function stopMultiTouch(event) {
  if (event.touches && event.touches.length > 1) {
    event.preventDefault();
  }
}

// 300ms 内的第二次点击视为双击，拦掉以免双击放大
function stopDoubleTap(event) {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}

// Safari 专有手势事件
function stopGesture(event) {
  event.preventDefault();
}

// 手指离开时统一检查一次，把可能已经发生的缩放纠正回去
function onTouchEnd(event) {
  stopDoubleTap(event);
  enforceScale();
}

// Safari 手势结束时同样检查
function onGestureEnd(event) {
  event.preventDefault();
  enforceScale();
}

// 桌面浏览器：Ctrl + 滚轮
function stopCtrlWheel(event) {
  if (event.ctrlKey) event.preventDefault();
}

// 桌面浏览器：Ctrl/Cmd + 加号、减号、0
function stopCtrlKey(event) {
  if (!(event.ctrlKey || event.metaKey)) return;
  const keys = ['+', '-', '=', '0', 'Add', 'Subtract'];
  if (keys.indexOf(event.key) > -1) {
    event.preventDefault();
  }
}

export default function preventPageZoom() {
  if (typeof document === 'undefined' || installed) return;
  installed = true;

  // 进页面先锁一次，兜住 HTML 里没写全的情况
  lockViewport();

  document.addEventListener('touchstart', stopMultiTouch, { passive: false });
  document.addEventListener('touchmove', stopMultiTouch, { passive: false });
  document.addEventListener('touchend', onTouchEnd, { passive: false });

  document.addEventListener('gesturestart', stopGesture, { passive: false });
  document.addEventListener('gesturechange', stopGesture, { passive: false });
  document.addEventListener('gestureend', onGestureEnd, { passive: false });

  window.addEventListener('wheel', stopCtrlWheel, { passive: false });
  window.addEventListener('keydown', stopCtrlKey, { passive: false });
}
